import React from 'react';
import sprintf from 'sprintf';

class SMSocialTwitterLink extends React.Component {
  constructor(props) {
    super(props);
    this.clickTwitterLink = this.clickTwitterLink.bind(this);
  }

  clickTwitterLink() {
    // Google Analytics
    const gaLabel = this.props.gaLabel;
    if (typeof ga != 'function') {
      return;
    }
    ga('send', 'event', 'button', 'click', gaLabel);
  }

  render() {
    const url = this.props.url;
    const body = this.props.body;
    const twitterUrl = sprintf("https://twitter.com/intent/tweet?url=%s&text=%s", encodeURIComponent(url), encodeURIComponent(body));

    return (
      <a href={twitterUrl} target="_blank" onClick={this.clickLineLink} className="social-link__twitter referral__social-link-twitter">
        <i className="fa fa-twitter"></i>
      </a>
    );
  }
}

export default SMSocialTwitterLink;



// WEBPACK FOOTER //
// ./app/javascript/components/social/SMSocialTwitterLink.jsx